/**
 * Eine Position-Konfiguration für Cdk Overlay.
 * Sie ermöglicht das Overlay so darstellen, dass das immer innerhalb des Viewportes angezeigt wird.
 */
import { ConnectedPosition } from '@angular/cdk/overlay';

export const SPP_OVERLAY_POSITION_DROPDOWN: ConnectedPosition[] = [
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' }
];
